import {Drawer} from 'antd';
import React, {useEffect, useState} from 'react';
import ProCard from '@ant-design/pro-card';
import BASEURLCONFIG from '../../../../../../config/BASEURLCONFIG';

const DrawPreviewComponent = (props) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewFlag, setPreviewFlag] = useState(false);
  const {text, monitorNo, apiPath = '/api/previewBomDraw'} = props;

  useEffect(() => {
    const fetchData = async () => {
    };
    fetchData();
  }, []);

  return (
    (<>
      <a onClick={() => {
        if (monitorNo) {
          let params =
            '?type=MONITOR_NO' +
            '&includeQrCode=Y' +
            '&monitorNos=' + monitorNo;
          const href =
            window.location.origin +
            BASEURLCONFIG.ISWAN_MES_URL +
            apiPath +
            params;
          let previewUrl =
            window.location.origin +
            `/pdfjs/web/viewer.html?file=${encodeURIComponent(href)}`;
          console.log(previewUrl);
          setPreviewUrl(previewUrl);
          setPreviewFlag(true);
        }
      }}>{text || monitorNo}</a>
      {
        monitorNo && previewFlag && previewUrl && (
          <Drawer
            title={'图纸预览'}
            styles={{
              body: {
                padding: 0
              }
            }}
            destroyOnClose={true}
            maskClosable={true}
            keyboard={true}
            width={'65%'}
            open={previewFlag}
            onClose={() => {
              setPreviewFlag(false);
            }}
            closable={true}
          >
            {previewUrl && (
              <ProCard>
                {/*<ProDescriptions title={'图纸预览'}/>*/}
                {previewUrl ? (
                  <iframe
                    width={'100%'}
                    height={'800px'}
                    rootStyle={{border: 0}}
                    src={previewUrl}
                  />
                ) : null}
              </ProCard>
            )}
          </Drawer>
        )
      }
    </>)
  );
};

export default DrawPreviewComponent;
